import React from 'react';
import { Grid, TextField, Typography, Paper } from '@mui/material';

// Helper function to update nested state immutably.
const setNestedValue = (obj, path, value) => {
  const keys = path.split('.');
  const newObj = JSON.parse(JSON.stringify(obj)); // Create a deep copy to avoid mutation
  let current = newObj;

  // Traverse the path to the second-to-last key
  for (let i = 0; i < keys.length - 1; i++) {
    current = current[keys[i]];
  }
  
  // Set the value on the final key
  current[keys[keys.length - 1]] = value;
  
  return newObj;
};


const FinalDetailsForm = ({ data, onUpdate }) => {
  // --- THIS IS THE FIX ---
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const finalValue = type === 'number' ? Number(value) : value;
    
    // Use our new helper function to update the state correctly
    const updatedData = setNestedValue(data, name, finalValue);
    onUpdate(updatedData);
  };

  return (
    <Paper sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Your Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            required
            fullWidth
            label="Number of Adults"
            // The name is the "path" to the state property
            name="tripDetails.travelers.adults"
            type="number"
            value={data.tripDetails.travelers.adults}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 1 } }}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Number of Children"
            name="tripDetails.travelers.children"
            type="number"
            value={data.tripDetails.travelers.children}
            onChange={handleChange}
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Grid>
        {/* The rest of the fields will now work correctly with this new handler */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            required
            fullWidth
            label="Preferred Travel Dates"
            name="tripDetails.dates"
            value={data.tripDetails.dates}
            onChange={handleChange}
            helperText="e.g., Mid-August 2024"
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Approximate Budget"
            name="tripDetails.budget"
            value={data.tripDetails.budget}
            onChange={handleChange}
            helperText="e.g., $5000 USD per person"
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            required
            fullWidth
            label="Full Name"
            name="contactDetails.name"
            value={data.contactDetails.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField
            required
            fullWidth
            label="Email Address"
            name="contactDetails.email"
            type="email"
            value={data.contactDetails.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            required
            fullWidth
            label="Phone Number"
            name="contactDetails.phone"
            value={data.contactDetails.phone}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FinalDetailsForm;